module.exports = __webpack_public_path__ + "img/icon@2x.206443e0.png";